"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributedActivity = void 0;
const uuid_1 = require("uuid");
function uuidString() {
    return uuid_1.v4().replace(/-/g, '').toLowerCase();
}
class DistributedActivity {
    constructor(operationName) {
        this.operationName = operationName;
        this.startTimestamp = 0;
        this.endTimestamp = 0;
        this.rootId = uuidString();
        this.id = `|${this.rootId}.${uuidString()}.`;
        this.tracers = [];
    }
    get duration() {
        return this.endTimestamp - this.startTimestamp;
    }
    setParentId(parentId) {
        this.parentId = parentId;
        this.rootId = parentId.substring(1, parentId.indexOf('.'));
        this.id = `|${this.rootId}.${uuidString()}.`;
    }
    start() {
        this.startTimestamp = Date.now();
    }
    stop() {
        this.endTimestamp = Date.now();
    }
    createChild(operationName) {
        const activity = new DistributedActivity(operationName);
        activity.setParentId(this.id);
        return activity;
    }
    trace(handler, ...traceHandlers) {
        this.start();
        const allTraceHandlers = [...traceHandlers, ...this.tracers];
        const result = handler(this);
        Promise.resolve(result).then(() => {
            this.stop();
            for (const traceHandler of allTraceHandlers)
                traceHandler(this);
        }, () => {
            this.stop();
            for (const traceHandler of allTraceHandlers)
                traceHandler(this);
        });
        return result;
    }
    logDebug() {
        console.log(this.operationName);
        console.log('  ID: ' + this.id);
        console.log('  Parent ID: ' + this.parentId);
        console.log('  Root ID: ' + this.rootId);
        console.log('  Start: ' + this.startTimestamp);
        console.log('  Stop: ' + this.endTimestamp);
        console.log('  Duration: ' + this.duration);
    }
}
exports.DistributedActivity = DistributedActivity;
